import { useState } from 'react';
import { loginRequest, setToken } from '../utils/auth.js';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 28,
  boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
  width: '100%',
  maxWidth: 360,
};

const label = {
  fontSize: 13,
  fontWeight: 600,
  marginBottom: 6,
  display: 'block',
  color: '#1e293b',
};

const inputBase = {
  fontSize: 14,
  padding: '10px 12px',
  border: '1px solid #cbd5e1',
  borderRadius: 6,
  width: '100%',
  boxSizing: 'border-box',
  marginBottom: 14,
};

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const data = await loginRequest(email.trim(), password);
      setToken(data.access_token);
      onLogin?.(data);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0f172a',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <div style={card}>
        <div style={{ marginBottom: 18 }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>MCC Quote Engine</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>
            Sign in with your paneliq account to continue.
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <label style={label} htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={submitting}
            style={inputBase}
          />

          <label style={label} htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={submitting}
            style={inputBase}
          />

          {error && (
            <div
              style={{
                background: '#fee2e2',
                color: '#991b1b',
                border: '1px solid #fca5a5',
                borderRadius: 6,
                padding: '8px 12px',
                fontSize: 13,
                marginBottom: 14,
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting || !email || !password}
            style={{
              width: '100%',
              fontSize: 14,
              fontWeight: 700,
              padding: '11px 16px',
              border: 'none',
              borderRadius: 6,
              color: '#fff',
              background: submitting || !email || !password ? '#94a3b8' : '#2563eb',
              cursor: submitting || !email || !password ? 'not-allowed' : 'pointer',
            }}
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
